var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_981_1404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.497 54.7492L36.2141 63.6656L38.8938 53.6347L34.6627 51.8235L45.3815 43.0464L35.6499 33.4334L33.2523 41.7926L26.2005 49.4551H19.8538L19.4307 54.3313H17.4562C16.7792 54.8885 15.1056 55.2136 14.3534 55.3065C13.9021 55.418 13.9773 50.0588 14.0713 47.3653L15.3407 46.1115V44.3003L15.9048 43.743H20.559L21.9694 42.2105V36.9164L22.5335 36.3591L27.1877 37.0557L35.932 28L48.6253 41.5139L52.0102 39.4241L62.5879 52.3808L66.819 51.9628L86 73L65.6907 56.2817L62.0238 57.1176L51.5871 44.5789L47.497 54.7492Z",
    fill: "#009DFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_981_1404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLogo);
export default __webpack_public_path__ + "static/media/MiniLogo.239402e85d3e6afda81f4381a147356c.svg";
export { ForwardRef as ReactComponent };